var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMovie = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Ticket-Movie--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Ticket Movie Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 9a1 1 0 0 0 1 -1V5.5A2.5 2.5 0 0 0 21.5 3h-19A2.5 2.5 0 0 0 0 5.5V8a1 1 0 0 0 1 1 3 3 0 0 1 0 6 1 1 0 0 0 -1 1v2.5A2.5 2.5 0 0 0 2.5 21h19a2.5 2.5 0 0 0 2.5 -2.5V16a1 1 0 0 0 -1 -1 3 3 0 0 1 0 -6ZM12 5a1 1 0 1 1 -1 1 1 1 0 0 1 1 -1ZM6 19a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1ZM6 7a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm6 12a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm3.21 -7.43 -1.35 1.08a0.29 0.29 0 0 0 -0.08 0.29l0.66 1.75a0.5 0.5 0 0 1 -0.16 0.57 0.51 0.51 0 0 1 -0.6 0l-1.54 -1.1a0.26 0.26 0 0 0 -0.29 0l-1.54 1.1a0.51 0.51 0 0 1 -0.6 0 0.5 0.5 0 0 1 -0.16 -0.57l0.66 -1.75a0.29 0.29 0 0 0 -0.08 -0.29l-1.35 -1.08a0.52 0.52 0 0 1 -0.16 -0.57 0.5 0.5 0 0 1 0.47 -0.33h1.44a0.25 0.25 0 0 0 0.24 -0.16l0.77 -1.83a0.51 0.51 0 0 1 0.46 -0.3 0.53 0.53 0 0 1 0.46 0.31l0.77 1.83a0.24 0.24 0 0 0 0.23 0.16h1.44a0.5 0.5 0 0 1 0.47 0.33 0.5 0.5 0 0 1 -0.16 0.56ZM18 19a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm0 -12a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMovie);
export default ForwardRef;